// Tennis Bet Products hub — the index of every standalone tennis product
// screen. Generated from the registry; each card deep-links to that product's
// own screen. Mirrors how the football product pages are reached.
import { Link } from "react-router-dom";
import { useUserTier } from "../../../auth/useUserTier.ts";
import { tierMeets } from "../../../auth/tier-gates.ts";
import { Card, Badge, Kicker, TennisHeader, StatusPill, daysUntil, R1_DATE } from "../_kit.tsx";
import { TENNIS_PRODUCTS, type TennisProduct } from "./registry.ts";

function ProductTile({ p, tierCode }: { p: TennisProduct; tierCode: string | null }): JSX.Element {
  const unlocked = tierMeets(tierCode, p.tier);
  return (
    <Link to={`/exchange/tennis/p/${p.slug}`} className="tn-card" style={{ textDecoration: "none", display: "block" }}>
      <div className="tn-card__head">
        <Kicker>{p.tagline}</Kicker>
        <div className="tn-card__title">
          <span className="tn-prod__title">
            {/* Tier chip only shows when it's a real gate for the viewer. */}
            {p.name} {!unlocked ? <Badge tone="info">{p.tierLabel}</Badge> : null}
          </span>
        </div>
      </div>
      <div className="tn-card__body">
        <p className="tn-card__lead">{p.what}</p>
        <span className="tn-cta tn-cta--ghost">Open {p.name} →</span>
      </div>
    </Link>
  );
}

export function TennisProductsHub(): JSX.Element {
  const { tierCode } = useUserTier();
  const live = daysUntil(R1_DATE) === 0;
  const volume = TENNIS_PRODUCTS.filter((p) => p.family === "volume");
  const layers = TENNIS_PRODUCTS.filter((p) => p.family === "layer");
  return (
    <div className="tn">
      <TennisHeader
        eyebrow="Tennis · Bet Products"
        title="Bet Products"
        meta={<StatusPill live={live}>{live ? "Pilot · live" : "Pilot · pre-tournament"}</StatusPill>}
      />
      <Card
        accent
        eyebrow="Every product · one screen each"
        title="Suggested accas & picks to stake"
        lead="Each product has its own screen that surfaces its suggested acca or picks. All honest-empty until the pipeline produces real signals — no fabricated slips."
      />

      <Card eyebrow="Volume products" title="High-cadence — the daily/jackpot stack" />
      <div className="tn-grid">
        {volume.map((p) => <ProductTile key={p.slug} p={p} tierCode={tierCode} />)}
      </div>

      <Card eyebrow="Intelligence layers" title="Edge-driven — staked as their own products" />
      <div className="tn-grid">
        {layers.map((p) => <ProductTile key={p.slug} p={p} tierCode={tierCode} />)}
      </div>
    </div>
  );
}
